// actions/connect/offline.js

import { attachAuth } from '../../utils/authService';
import PubSub         from 'pubsub-js';

// --- ALL ---

export function connectOfflineHasErrored(bool) {
  return {
    type: 'CONNECT_OFFLINE_HAS_ERRORED',
    hasErrored: bool
  };
}

export function connectOfflineIsLoading(bool) {
  return {
    type: 'CONNECT_OFFLINE_IS_LOADING',
    isLoading: bool
  };
}

export function connectOfflineFetchDataSuccess(obj) {
  return {
    type: 'CONNECT_OFFLINE_FETCH_DATA_SUCCESS',
    obj
  };
}

export function connectOfflineFetchData(host, body) {
  return (dispatch) => {
    dispatch(connectOfflineIsLoading(true));
    dispatch(connectOfflineHasErrored(false));
    fetch(host + 'connect/offline', {
      method: 'post',
      body: JSON.stringify(body),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          promise.json()
          .then(result => {
            PubSub.publish('connect.chat.offline.error', result);
          })
          .catch((ex) => {
            console.log(ex);
            PubSub.publish('connect.chat.offline.error', ex);
          });
          
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(connectOfflineFetchDataSuccess(result));
            dispatch(connectOfflineHasErrored(false));
            dispatch(connectOfflineIsLoading(false));
            PubSub.publish('connect.chat.offline.result', result);
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(connectOfflineHasErrored(true));
            dispatch(connectOfflineIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(connectOfflineHasErrored(true));
      dispatch(connectOfflineIsLoading(false));
    });
  };
}